import type { ComponentProps } from "react"
import { forwardRef } from "react"

export const SlaBreachIcon = forwardRef<SVGSVGElement, ComponentProps<"svg">>(
	({ className, ...props }, ref) => (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="currentColor"
			ref={ref}
			{...props}
			className={className}
		>
			<path
				opacity="0.8"
				d="M8.80596 1.18963C9.72001 0.636732 9.64134 1.38807 9.55419 2.22044C9.52749 2.47541 9.5 2.73798 9.5 2.97299C9.5 3.97525 10.5 5.45947 11 5.97974C11.0494 6.03112 11.0988 6.08213 11.1477 6.13234C10.7791 6.04579 10.3949 6 10 6C7.23858 6 5 8.23858 5 11C5 12.5549 5.70979 13.9441 6.82304 14.8611C4.62954 14.3336 3 12.3644 3 10.0159C3 9.56439 3.07417 9.21357 3.14556 8.87587C3.2348 8.45375 3.3197 8.05214 3.25 7.5C3.21712 7.23955 3.16701 7.01981 3.12027 6.81482C3.05706 6.53764 3 6.28743 3 6C3 5 4.34867 5.95895 5 6.5L6 7.45656V5.53023C6 4.11834 6.66687 2.78883 7.8 1.94169L8.80596 1.18963Z"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M10 15C12.2091 15 14 13.2091 14 11C14 8.79086 12.2091 7 10 7C7.79086 7 6 8.79086 6 11C6 13.2091 7.79086 15 10 15ZM11.9446 9.05568C12.1399 9.25094 12.1399 9.56752 11.9446 9.76279L10.7099 10.9975L10.8261 11.1146C11.1766 11.4673 11.5397 11.8328 11.9446 12.2377C12.1398 12.433 12.1398 12.7495 11.9446 12.9448C11.7493 13.1401 11.4327 13.1401 11.2375 12.9448C10.8277 12.535 10.4629 12.1678 10.1118 11.8144L10.0028 11.7047L8.76266 12.9447C8.5674 13.14 8.25082 13.14 8.05556 12.9447C7.8603 12.7495 7.8603 12.4329 8.05556 12.2376L9.29733 10.9959C8.9117 10.6095 8.51285 10.2124 8.05846 9.76573C7.86155 9.57213 7.85886 9.25556 8.05245 9.05865C8.24605 8.86173 8.56262 8.85904 8.75953 9.05263C9.21521 9.50062 9.61664 9.90026 10.0044 10.2888L11.2375 9.05568C11.4328 8.86042 11.7494 8.86042 11.9446 9.05568Z"
			/>
		</svg>
	),
)
